export default [
    {
        num: 0,
        label: {
            en: 'Pending',
            et: 'Kinnitamata',
            ru: 'Не подтверждён',
            lv: "Nav apstiprināts",
            lt: "Nepatvirtinta",
            fi: "Vahvistamatta",
            // ru: 'Требует подтверждения',
        },
        color: 'black'
    },
    {
        num: 1,
        label: {
            en: 'Approved',
            et: 'Kinnitatud',
            ru: 'Подтверждён',
            lv: "Apstiprināts",
            lt: "Patvirtinta",
            fi: "Vahvistettu",
        },
        color: 'green'
    },
    // {
    //     num: 1,
    //     label: {
    //         en: 'New',
    //         et: 'Uus',
    //         ru: 'Новый',
    //     },
    //     color: 'green'
    // },
    {
        num: 2,
        label: {
            en: 'Approval',
            et: 'Kooskõlastamine',
            ru: 'Согласование',
            lv: "Saskaņošana",
            lt: "Derinama",
            fi: "Hyväksyttävänä",
        },
        color: 'orange'
    },
    {
        num: 3,
        label: {
            en: 'Waiting',
            et: 'Ootel',
            ru: 'Ожидание',
            lv: "Gaida",
            lt: "Laukiama",
            fi: "Odottaa",
        },
        color: 'yellow'
    },
    {
        num: 5,
        label: {
            en: 'In progress',
            et: 'Töös',
            ru: 'В работе',
            lv: "Darbā",
            lt: "Vykdoma",
            fi: "Työn alla",
        },
        color: 'purple'
    },
    {
        num: 7,
        label: {
            en: 'Completed',
            et: 'Valmis',
            ru: 'Выполнен',
            lv: "Izpildīts",
            lt: "Įvykdyta",
            fi: "Valmis",
        },
        color: 'blue'
    },
    // {
    //     num: 8,
    //     label: {
    //         en: 'Issued',
    //         et: 'Valmis',
    //         ru: 'Väljastatud',
    //     },
    //     color: 'blue'
    // },
    {
        num: 8,
        label: {
        //     en: 'Issued',
        //     et: 'Väljastatud',
        //     ru: 'Выдан',
            en: 'Released',
            et: 'Väljastatud',
            ru: 'Выдан',
            lv: "Izsniegts",
            lt: "Atiduota",
            fi: "Luovutettu",
            // en: 'Vehicle released',
            // et: 'Sõiduk väljastatud',
            // ru: 'Авто выдан'
        },
        color: 'dark-blue'
    },
    {
        num: 9,
        label: {
            // en: 'Part. paid',
            // et: 'Osal. tasutud',
            // ru: 'Част. опл.',
            en: 'Partially paid',
            et: 'Osaliselt tasutud',
            ru: 'Оплачен частично',
            lv: "Daļēji apmaksāts",
            lt: "Iš dalies apmokėta",
            fi: "Osittain maksettu",
        },
        color: 'blue'
    },
    {
        num: 10,
        label: {
            en: 'Paid',
            et: 'Tasutud',
            ru: 'Оплачен',
            lv: "Apmaksāts",
            lt: "Apmokėta",
            fi: "Maksettu",
        },
        color: 'dark-blue'
    },
    {
        num: 12,
        label: {
            en: 'Canceled',
            et: 'Tühistatud',
            ru: 'Отменен',
            lv: "Atcelts",
            lt: "Atšaukta",
            fi: "Peruttu",
        },
        color: 'red'
    },
]